import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  Spinner, Stack, Text
} from "@chakra-ui/react";
import { useQuery, useQueryClient} from "react-query";
import {useNavigate} from "react-router-dom";

import { activeTestsCompleted, SATSurveyCompleted } from "../../shared/Api";
import {useFont} from "../../shared/hooks/FontProvider";
import {useTheme} from "../../shared/hooks/ThemeProvider";
import {Paths} from "../../shared/model/Constants";
import {userKeys} from "../QueryKeys";
import {extractData} from "../Utils";

const SATSurveyCard = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const themeContext = useTheme();
  const fontContext = useFont();

  const completedCandidatesQuery = useQuery(userKeys.activeTestsCompleted(), () =>
  { return activeTestsCompleted().then(extractData); });

  const surveyQuery = useQuery(userKeys.SATSurvey(), () =>
  { return SATSurveyCompleted().then(extractData); });

  if ( completedCandidatesQuery.isLoading || surveyQuery.isLoading ) {
    return <Spinner />;
  } else if ( (completedCandidatesQuery.data!==null && completedCandidatesQuery.data === false)
      || (surveyQuery.data!==null && surveyQuery.data ===true) ){
    return <></>;
  } else return (
    <>
      <Button onClick={()=>navigate(Paths.SAT_SURVEY)}
               colorScheme={themeContext.theme.SPECIAL_SCHEME}
               fontWeight={fontContext.font.weight}
               fontSize={fontContext.font.p}
      >
            Encuesta de satisfacción
      </Button>
    </>
  );
};

export default SATSurveyCard;